import { Component } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';
import { BaseModalComponent } from '../base-modal.component';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { Controller } from '../../../../../coverpath-client/public/js/Controller';
import { FormService } from '../../../services/form/form.service';

@Component({
  templateUrl: './confirm-legal-guardian.component.html',
})
export class ConfirmLegalGuardianComponent extends BaseModalComponent {
  controller: Controller;

  constructor(
    private amorphicService: AmorphicService,
    protected modalService: ModalService,
    private formService: FormService
  ) {
    super(modalService);
    this.controller = this.amorphicService.controller as Controller;
  }

  cancel() {
    this.resetSignerDetails();
    this.modalService.deactivate();
  }

  confirm() {
    this.updateRelationship();
    this.modalService.deactivate();
  }

  updateRelationship() {
    const ward =
      this.controller.customer.application.primaryPolicy.insured.person.gender === '1' ? 'maleward' : 'femaleward';
    this.formService.submitValueAndFireTriggers('customer.application.primaryPolicy.insuredType', ward);
    this.formService.submitValueAndFireTriggers('customer.application.primaryPolicy.insured.hasSigner', false);
  }

  resetSignerDetails() {
    this.formService.submitValueAndFireTriggers('customer.application.primaryPolicy.insured.hasSigner', undefined);
  }
}
